/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Slip_HeadingInputs */

const vi_cdo_slip_heading = /** @type {(inputs: Cdo_Slip_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PHIẾU GIAO HỢP ĐỒNG`)
};

/**

* @param {Cdo_Slip_HeadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_slip_heading = /** @type {((inputs?: Cdo_Slip_HeadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Slip_HeadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_slip_heading(inputs)
});